module.exports = __webpack_public_path__ + "img/workout-experience.c0b1ce63.svg";